import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import {
  makeThemedStyles,
  themedElement,
} from "@qpr/client-api-base/viewcomponents/utils";

export const TblBodyCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    color: "rgba(107, 114, 128, 1)",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 500,
  },
  body: {
    fontSize: 14,
    background: "none",
    whiteSpace: "nowrap",
  },
}))(TableCell);

const useStyles = makeStyles({
  table: {},
  title: {
    fontSize: "1.828em",
    lineHeight: "1.5em",
    letterSpacing: "0.05625px",
    color: "rgba(63, 69, 79, 1)",
    margin: 0,
    marginBottom: "0.625em",
    fontWeight: 600,
  },
});

export const TblHead = TableHead;
export const TblHeadRow = TableRow;
export const TblHeadCell = TblBodyCell;
export const TblBody = TableBody;
export const TblBodyRow = withStyles((theme) => ({
  root: {
    /*
    "&:last-child td": {
      background: "rgba(118, 188, 122, 0.08)",
      color: "rgba(117, 187, 121, 1)",
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: 600,
      
    },
    */
  },
}))(TableRow);

export const Tbl = (props: React.PropsWithChildren<{}>) => {
  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table
        style={{ tableLayout: "auto" }}
        className={classes.table}
        aria-label="customized table"
      >
        {props.children}
      </Table>
    </TableContainer>
  );
};
